/**
 * Attendance policy constants for DISPLAY ONLY.
 * The backend engine is authoritative — the admin app never computes a
 * status client-side; these strings surface the policy in tooltips/captions.
 */
export type AttendanceComputedStatus =
  | 'PRESENT'
  | 'LATE_CHECK_IN'
  | 'HALF_DAY'
  | 'ABSENT'
  | 'LEAVE'
  | 'HOLIDAY'
  | 'WEEKLY_OFF';

export const COMPUTED_STATUSES: AttendanceComputedStatus[] = [
  'PRESENT',
  'LATE_CHECK_IN',
  'HALF_DAY',
  'ABSENT',
  'LEAVE',
  'HOLIDAY',
  'WEEKLY_OFF',
];

export const LATE_CUTOFF_LABEL = '10:45 AM';
export const HALF_DAY_CUTOFF_LABEL = '12:00 PM';
export const SHIFT_WINDOW_LABEL = '10:00 AM – 8:00 PM';
export const CHECKOUT_WINDOW_LABEL = '8:00 PM – 8:30 PM';
export const FULL_DAY_HOURS_LABEL = '8 hours';
export const HALF_DAY_HOURS_LABEL = '5 hours';

export const POLICY_HINTS: Record<string, string> = {
  PRESENT: `Checked in by ${LATE_CUTOFF_LABEL} with ≥ ${FULL_DAY_HOURS_LABEL} worked`,
  LATE_CHECK_IN: `Checked in after ${LATE_CUTOFF_LABEL} (until ${HALF_DAY_CUTOFF_LABEL})`,
  HALF_DAY: `Between ${HALF_DAY_HOURS_LABEL} and ${FULL_DAY_HOURS_LABEL} worked, or checked in after ${HALF_DAY_CUTOFF_LABEL}`,
  ABSENT: `No check-in, missing checkout, or under ${HALF_DAY_HOURS_LABEL} worked`,
  LEAVE_NO_INFO: 'Marked as leave but no approved leave request or reason on file',
  WEEKLY_OFF: 'Sunday weekly off — paid, excluded from deductions',
  LATE_CONVERSION: '3 late check-ins = 1 half-day deduction',
  HALF_DAY_CONVERSION: '2 half-day equivalents = 1 absent day',
};

